import Delta from 'quill-delta';
import QuillField from 'packages/kakapo-ui-kit/components/editors/QuillField';

export default function OpenQuestionInput(props: {
	name: string;
	autoFocus?: boolean;
	initialValue?: Delta;
}) {
	return (
		<QuillField name={props.name} wide boxedStyling theme="snow" autoFocus={props.autoFocus} />
	);
}
